import { render, staticRenderFns } from "./AccessWalletTrezor.vue?vue&type=template&id=60399a30&"
import script from "./AccessWalletTrezor.vue?vue&type=script&lang=js&"
export * from "./AccessWalletTrezor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports